var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',_vm._l((_vm.chapters),function(chapter,index){return _c('li',[_c('router-link',{class:{active: index == _vm.idActive},attrs:{"to":'/digitalkompetens/'+_vm.routeTrack+'/'+(index+1)}},[_vm._v("\n        "+_vm._s(chapter.data().header)+"\n      ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d30850","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/Chapters.vue
// module id = null
// module chunks = 